import ModelLeanist from "./leanist/ModelLeanist.js";

export const AccountM = new ModelLeanist('Account');
export const FollowedAccountM = new ModelLeanist('FollowedAccount');
export const LeanCanvasM = new ModelLeanist('LeanCanvas');
export const LeanCanvasItemM = new ModelLeanist('LeanCanvasItem');
export const LeanCanvasViewM = new ModelLeanist('LeanCanvasView');
export const LeanCanvasSaveM = new ModelLeanist('LeanCanvasSave');
export const LeanCanvasShareM = new ModelLeanist('LeanCanvasShare');
export const LeanCanvasCommentM = new ModelLeanist('LeanCanvasComment');
export const LeanistQuestionsM = new ModelLeanist('LeanistQuestions');
export const LeanCanvasInviteM = new ModelLeanist('LeanCanvasInvite');
